import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { deviceMin, deviceMax } from 'utils/styles/breakpoints';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const SubscribeNotificationWrapper = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenColumn}
  margin: 80px auto;
  height: auto;

  @media only screen and ${deviceMax.tabletS} {
    width: 382px;
    height: auto;
  }

  @media only screen and ${deviceMax.mobilePlus} {
    width: 294px;
    height: 210px;
  }
`;

export const SubscriptionText = styled.p`
  ${FONTS.font16}
  color: ${COLORS.white};
  ${FONT_FAMILY.FontRegular}
  text-align: center;
  padding-bottom: 10px;

  @media only screen and ${deviceMax.laptopM} {
    ${FONTS.font16}
  }

  @media only screen and ${deviceMax.mobilePlus} {
    ${FONTS.font14}
  }
`;

export const SubscribeForInformation = styled.div`
  width: max-content;
  height: 56px;
  border-radius: 5px;

  @media only screen and ${deviceMax.laptopM} {
    width: 420px;
    height: 45px;
  }

  @media only screen and ${deviceMax.tabletS} {
    width: 383px;
  }

  @media only screen and ${deviceMax.mobilePlus} {
    ${FLEX_CONTAINER.FlexCenterRow}
    width: 294px;
    flex-wrap: wrap;
    gap: 20px;
  }
`;

export const EmailAddressInput = styled.input`
  ${FONT_FAMILY.FontLight}
  ${FONTS.font16}
  width: 350px;
  height: 56px;
  background: ${COLORS.strongWhite};
  padding-left: 12px;
  border-radius: 12px 0px 0px 12px;
  border: ${({ error }) => error && `1px solid ${COLORS.red}`};

  @media only screen and ${deviceMax.laptopM} {
    width: 282px;
    height: 45px;
    ${FONTS.font16}
  }

  @media only screen and ${deviceMax.tabletS} {
    width: 237px;
    height: 40px;
  }

  @media only screen and ${deviceMax.mobilePlus} {
    width: 100%;
    border-radius: 12px;
  }
`;

export const SubmitButton = styled.button`
  width: 171px;
  height: 56px;
  background: ${COLORS.blue};
  border-radius: 0px 12px 12px 0px;
  color: ${COLORS.white};
  ${FONT_FAMILY.FontRegular}
  ${FONTS.font16}

  @media only screen and ${deviceMax.laptopM} {
    width: 138px;
    height: 45px;
    ${FONTS.font16}
  }

  @media only screen and ${deviceMax.tabletS} {
    width: 145px;
    height: 40px;
  }

  @media only screen and ${deviceMax.mobilePlus} {
    width: 100%;
    border-radius: 12px;
  }
`;

export const SubscribeSuccess = styled.p`
  color: ${COLORS.lightGray};
  ${FONTS.font36};
  text-align: center;
  min-width: max-content;
  margin-top: 10px;
  @media ${deviceMin.mobileS} {
    ${FONTS.font16}
  }

  @media ${deviceMin.mobileL} {
    ${FONTS.font16}
  }

  @media ${deviceMin.tablet} {
    ${FONTS.font24}
  }

  @media ${deviceMin.laptopL} {
    ${FONTS.font24}
  }
  @media ${deviceMin.desktop} {
    ${FONTS.font36};
  }
`;

export const ErrorMessage = styled.span`
  color: ${COLORS.red};
  ${FONTS.font12};
  margin-top: 8px;
  margin-right: 240px;
  height: 14px;
  min-width: max-content;
  @media only screen ${deviceMin.mobileS} {
    margin-top: 70px;
  }
`;
